// import React, { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import { Form, Button, Row, Col } from 'react-bootstrap'
// import { useDispatch, useSelector } from 'react-redux'
// import Message from '../components/Message'
// import Loader from '../components/Loader'
// import FormContainer from '../components/FormContainer'
// import { login } from '../actions/userActions'
// import ReCAPTCHA from "react-google-recaptcha"


// import { useRef } from 'react'

// const LoginScreen = ({ location, history }) => {
//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [grecaptcha, setGrecaptcha] = useState('')
//   function onChange(value) {
//     console.log('Captcha value:', value)
//     setGrecaptcha(value)
//   }

//   const dispatch = useDispatch()

//   const userLogin = useSelector((state) => state.userLogin)
//   const { loading, error, userInfo, confirmationLink } = userLogin

//   const redirect = location.search ? location.search.split('=')[1] : '/'

//   useEffect(() => {
//     if (userInfo) {
//       history.push(redirect)
//     }
//   }, [history, userInfo, redirect])

//   useEffect(() => {
//     if (error) {
//       window.grecaptcha.reset()
//     }
//   }, [error])

  
//   const submitHandler = (e) => {
//     e.preventDefault()
//     dispatch(login(email, password, grecaptcha))
//   }

//   return (
//     <FormContainer>
//       <h1>Sign In</h1>
      
//       {error && <Message variant='danger'>{error}</Message>}
//       {confirmationLink ? <Row className='py-3'>
//         <Col>
//           <Link to={redirect ? `/resendconfirmation?redirect=${redirect}` : '/resendconfirmation'}>
//             Resend Confirmation Email
//           </Link>
//         </Col>
//       </Row> : <p></p>}
//       {loading && <Loader />}
//       <Form onSubmit={submitHandler}>
//         <Form.Group controlId='email'>
//           <Form.Label>Email Address</Form.Label>
//           <Form.Control
//             type='email'
//             placeholder='Enter email'
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           ></Form.Control>
//         </Form.Group>
//       <span></span>

//         <Form.Group className="mb-3" controlId='password'>
//           <Form.Label>Password</Form.Label>
//           <Form.Control
//             type='password'
//             placeholder='Enter password'
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           ></Form.Control>
//         </Form.Group>

//         <Form.Group className="mb-3" controlId='recaptcha'>
//           <ReCAPTCHA controlId='grecaptcha'
//    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
//     onChange={onChange}
//   />
//         </Form.Group>

//         <Button type='submit' variant='primary'>
//           Sign In
//         </Button>
//       </Form>

//       <Row className='py-3'>
//         <Col>
//           New Customer?{' '}
//           <Link to={redirect ? `/register?redirect=${redirect}` : '/register'}>
//             Register
//           </Link>
//         </Col>
//       </Row>

//       <Row className='py-3'>
//         <Col>
//           Forgot Password?{' '}
//           <Link to={redirect ? `/forgotpw?redirect=${redirect}` : '/forgotpw'}>
//             Forgot Password
//           </Link>
//         </Col>
//       </Row>
//     </FormContainer>
//   )
// }

// export default LoginScreen
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import { login } from '../slices/userSlice'; // using your slice now!
import ReCAPTCHA from 'react-google-recaptcha';
import Meta from '../components/Meta';
import PasswordInput from '../components/PasswordInput';

// --- Helpers & constants for login input sanitation/UX ---
const MAX_EMAIL_LEN = 254;
const SUBMIT_MIN_INTERVAL_MS = 1500;
const EMAIL_DEBOUNCE_MS = 300;
const PASSWORD_HINT_DELAY_MS = 1500;
const HTML_TAG_REGEX = /<[^>]+>/;
const BASIC_EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const normalizeNFC = s => { try { return (s||'').normalize('NFC'); } catch { return s||''; } };
// Replace stripControl regex with loop-based sanitizer (no regex with control chars)
const stripControl = (s) => {
  const str = s || '';
  let out = '';
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code > 31 && code !== 127) out += str[i];
  }
  return out;
};
const sanitizeEmail = raw => {
  let v = stripControl(normalizeNFC(String(raw||''))).trim().toLowerCase();
  if (v.length > MAX_EMAIL_LEN) v = v.slice(0, MAX_EMAIL_LEN);
  return v;
};
const sanitizePassword = raw => stripControl(String(raw||'')); // DO NOT trim or change case
const hasHTML = s => HTML_TAG_REGEX.test(s||'');

const LoginScreen = ({ location, history }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [grecaptcha, setGrecaptcha] = useState('');
  const [fieldErrors, setFieldErrors] = useState({ email:'', password:'', grecaptcha:'' });
  const [emailDirty, setEmailDirty] = useState(false);
  const [showPasswordHint, setShowPasswordHint] = useState(false);
  const [rateLimited, setRateLimited] = useState(false);
  const [passwordWhitespaceWarn, setPasswordWhitespaceWarn] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const lastSubmitTs = useRef(0);
  const emailDebounceTimer = useRef(null);
  const passwordHintTimer = useRef(null);

  const dispatch = useDispatch();

  // Using state.user from userSlice (no longer userLogin)
  const user = useSelector((state) => state.user);
  const { loading, error, userInfo } = user;

  const redirect = location.search ? location.search.split('=')[1] : '/';

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
  }, [history, userInfo, redirect]);

  useEffect(() => {
    if (error) {
      window.grecaptcha?.reset();
    }
  }, [error]);

  const runEmailValidation = () => {
    setFieldErrors(prev => {
      if (!emailDirty) return prev; // defer until user has interacted
      let err = '';
      if (!email) err = 'Email required';
      else if (hasHTML(email)) err = 'Invalid';
      else if (!BASIC_EMAIL_REGEX.test(email)) err = 'Invalid email format';
      return { ...prev, email: err };
    });
  };

  const validateAll = (vals) => {
    const errs = { email:'', password:'', grecaptcha:'' };
    if (!vals.email) errs.email = 'Email required';
    else if (hasHTML(vals.email)) errs.email = 'Invalid';
    else if (!BASIC_EMAIL_REGEX.test(vals.email)) errs.email = 'Invalid email format';
    if (!vals.password) errs.password = 'Password required';
    if (!vals.grecaptcha) errs.grecaptcha = 'Captcha required';
    return errs;
  };

  // Email change handler with debounce
  const handleEmailChange = raw => {
    const sanitized = sanitizeEmail(raw);
    if (process.env.NODE_ENV !== 'production' && raw && raw !== sanitized) console.log('email normalized:', raw, '->', sanitized);
    setEmail(sanitized);
    if (!emailDirty) setEmailDirty(true);
    if (emailDebounceTimer.current) clearTimeout(emailDebounceTimer.current);
    emailDebounceTimer.current = setTimeout(runEmailValidation, EMAIL_DEBOUNCE_MS);
  };

  // Password handlers
  const handlePasswordFocus = () => {
    if (passwordHintTimer.current) clearTimeout(passwordHintTimer.current);
    passwordHintTimer.current = setTimeout(() => {
      if (!password && emailDirty) setShowPasswordHint(true);
    }, PASSWORD_HINT_DELAY_MS);
  };
  const handlePasswordChange = raw => {
    const sanitized = sanitizePassword(raw);
    setPassword(sanitized);
    if (sanitized) setShowPasswordHint(false);
    let warn = '';
    if (/^\s|\s$/.test(sanitized)) warn = 'Leading/trailing spaces kept';
    setPasswordWhitespaceWarn(warn);
    setFieldErrors(prev => ({ ...prev, password: sanitized ? '' : 'Password required' }));
  };
  const handlePasswordBlur = () => {
    if (passwordHintTimer.current) clearTimeout(passwordHintTimer.current);
  };

  // Cleanup timers on unmount
  useEffect(() => () => {
    if (emailDebounceTimer.current) clearTimeout(emailDebounceTimer.current);
    if (passwordHintTimer.current) clearTimeout(passwordHintTimer.current);
  }, []);

  const onChange = (value) => {
    setGrecaptcha(value);
    setFieldErrors(prev => ({ ...prev, grecaptcha: '' }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const now = Date.now();
    if (now - lastSubmitTs.current < SUBMIT_MIN_INTERVAL_MS) {
      setRateLimited(true);
      setTimeout(() => setRateLimited(false), 1000);
      return;
    }
    const sanitizedEmail = sanitizeEmail(email);
    const sanitizedPassword = sanitizePassword(password);
    const errs = validateAll({ email: sanitizedEmail, password: sanitizedPassword, grecaptcha });
    setFieldErrors(errs);
    const hasErr = Object.values(errs).some(Boolean);
    if (hasErr) return;
    lastSubmitTs.current = now;
    // Dispatch with sanitized values
    dispatch(login({ email: sanitizedEmail, password: sanitizedPassword, grecaptcha, rememberMe }));
  };

  const disableSubmit = loading || rateLimited || !email || !password || !grecaptcha || !!fieldErrors.email || !!fieldErrors.password;

  return (
    <FormContainer>
      <Meta title='Sign In — lotustor.com' robots='noindex,follow' />
      <h1>Sign In</h1>
      {error && <Message variant='danger'>{error}</Message>}
      {fieldErrors.grecaptcha && <Message variant='danger'>{fieldErrors.grecaptcha}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type='email'
            placeholder='Enter email'
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
          />
          {fieldErrors.email && <small className='text-danger'>{fieldErrors.email}</small>}
        </Form.Group>
        <PasswordInput
          id="password"
          label="Password"
          value={password}
          onChange={(e) => handlePasswordChange(e.target.value)}
          onFocus={handlePasswordFocus}
          onBlur={handlePasswordBlur}
          errorText={fieldErrors.password}
          autoComplete="current-password"
        />
        {showPasswordHint && !password && !fieldErrors.password && <small className='text-muted'>Enter your password to continue.</small>}
        {passwordWhitespaceWarn && <small className='text-warning d-block'>{passwordWhitespaceWarn}</small>}
        <Form.Group className='mb-3' controlId='recaptcha'>
          <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''} onChange={onChange} />
        </Form.Group>
        <Form.Group className='mb-3' controlId='rememberMe'>
          <Form.Check
            type='checkbox'
            label='Remember me'
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
        </Form.Group>
        {rateLimited && <small className='text-muted d-block mb-2'>Please wait a moment before retrying.</small>}
        <Button type='submit' variant='primary' disabled={disableSubmit}>Sign In</Button>
      </Form>
      <Row className='py-3'>
        <Col>
          New Customer?{' '}<Link to={redirect ? `/register?redirect=${redirect}` : '/register'}>Register</Link>
        </Col>
      </Row>
      <Row className='py-3'>
        <Col>
          Forgot Password?{' '}<Link to={redirect ? `/forgotpw?redirect=${redirect}` : '/forgotpw'}>Forgot Password</Link>
        </Col>
      </Row>
    </FormContainer>
  );
};

export default LoginScreen;
